import { render } from "./GameMemory.vue?vue&type=template&id=ed654d1e&scoped=true&ts=true"
import script from "./GameMemory.vue?vue&type=script&lang=ts"
export * from "./GameMemory.vue?vue&type=script&lang=ts"

import "./GameMemory.vue?vue&type=style&index=0&id=ed654d1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed654d1e"]])

export default __exports__